import React from "react";
import { Tooltip } from "react-tooltip";
import { observer } from "mobx-react";

import { useParams } from "react-router-dom";

import {
	LookupContext,
	OfferOptionsContext,
	OfferStoreContext,
} from "@gp/components";

import { ErrorPage } from "@components-shared/desktop/error";
import { PrematchSportsList } from "@features/offer/desktop/view/PrematchSportsList";
import { SearchEmptyState } from "./components";

import SkeletonLoader from "@features/offer/desktop/selected-offer-categories/SkeletonLoader";
import { useSearchStore } from "@state/hooks/offer/useSearchStore";
import {
	additionalOfferToggle,
	useNumberOfAvailableColumns,
} from "@utils/offer";

import { useRootAppStore } from "@hooks";

import { SearchHeader } from ".";

export const SearchPage = observer(function SearchPage() {
	const { searchTerm } = useParams<{ searchTerm: string }>();
	const rootStore = useRootAppStore();
	const searchViewStore = useSearchStore(searchTerm);

	const { eventsInSports, isEmpty, isFetchingData, lookupsStore, onDispose } =
		searchViewStore;

	const numberOfColumns = useNumberOfAvailableColumns(
		rootStore.resizeStore.availableColumns
	);

	if (isFetchingData) {
		return (
			<SkeletonLoader
				quotasCount={rootStore.calculatedOfferColumnsNumber}
				isLoading
			/>
		);
	}

	if (isEmpty) {
		return <SearchEmptyState searchTerm={searchTerm} />;
	}

	return (
		<ErrorPage onError={onDispose}>
			<div className="l--content__main">
				{/* @ts-expect-error */}
				<OfferStoreContext.Provider value={searchViewStore}>
					<SearchHeader searchTerm={searchTerm} />

					<LookupContext.Provider value={lookupsStore}>
						<OfferOptionsContext.Provider
							value={{
								numberOfColumns,
								scoreChangeDuration: 3500,
								enableInlineAdditionalOffer: false,
								// @ts-expect-error
								additionalOfferToggle,
								isLive: false,
							}}
						>
							<PrematchSportsList
								sports={eventsInSports.sports}
							/>
						</OfferOptionsContext.Provider>
					</LookupContext.Provider>
				</OfferStoreContext.Provider>
			</div>

			<Tooltip
				id="bt-description"
				className="at-tooltipBettingType react-tooltip--primary"
				place="bottom"
				closeOnResize={true}
			/>
		</ErrorPage>
	);
});
